export const SensorNumberWidth = 32;
export const SensorNameWidth = 80;